<template>
  <div id="app">
    <navBar v-if="!login" />
    <right v-if="!login" />
    <router-view style="min-height: 100vh;" v-if="accToken" />
    <footerModal v-if="!login" />

    <!-- 浮条 -->
    <div class="FloatingBar" v-if="!hideFloating">
      <div class="FloatingBarBox">
        <span class="pcLogo">
          <img :src="pclogo" alt="">
        </span>
        <span class="FloatingTitle">幼师找工作，就上幼聘网</span>
        <span class="FloatingNum" style="margin-left: 50px;">
          <span>{{aggregate.vita_total}}</span>幼师
        </span>
        <span class="FloatingNum">
          <span>{{aggregate.school_total}}</span>园所
        </span>
        <span class="FloatingNum">
          <span>{{aggregate.job_total}}</span>职位
        </span>
        <span class="FloatingLogin" @click="goLogin">注册/登录</span>
        <span class="closeFloatingBar" @click="closeFloatingBar"><i class="el-icon-close"></i></span>
      </div>
    </div>
    <div class="FloatingBarHeight" v-if="!hideFloating"></div>
  </div>
</template>

<script>
import navBar from "@/components/jobNavBar";
import right from "@/components/right";
import footerModal from "@/components/footer";
import md5 from "js-md5";
import pclogo from '@/assets/pclogo.png'

export default {
  name: "App",
  components: {
    navBar,
    right,
    footerModal
  },
  data() {
    return {
      login: false,
      accToken: false,
      AccessToken: '',
      pclogo: pclogo,
      hideFloating: false,
      aggregate: {}
    };
  },
  watch: {
    $route(e) {
      if (
        this.$route.path === "/login" ||
        this.$route.path === "/boss/addSchool"
      ) {
        this.login = true;
      } else {
        this.login = false;
      }
    },
    AccessToken() {
      if(this.AccessToken) {
        this.accToken = true
      } else {
        this.accToken = false
      }
    }
  },
  created() {
    if(sessionStorage.getItem('area')) {
      let city_name = JSON.parse(sessionStorage.getItem('area')).city_name
      document.title = city_name + '幼师招聘网-海量'+city_name+'幼师招聘职位-幼聘网-中国幼师招聘网'
    } else {
      document.title = '幼聘网-中国幼师招聘网丨幼师找工作，就上幼聘网，全国幼师招聘平台'
    }
    
    if (!this.Cookies.get("DeviceId")) {
      this.api.get("/5cd8ef9a0b6be", {}).then(r => {
        this.Cookies.set("DeviceId", JSON.stringify(r.data), { expires: 1 });
        
        this.$nextTick(()=>{
          let str = `app_id=80905851&app_secret=tCVGTcYqkyhxDvjfwTXPKPiWqIPOjqjY&device_id=${
            JSON.parse(this.Cookies.get("DeviceId")).device_id
          }`;
          let md5str = md5(str);
          let obj = {
            app_id: "80905851",
            device_id: JSON.parse(this.Cookies.get("DeviceId")).device_id,
            signature: md5str
          };
          this.api.post("/5cb6a46030b2d", obj).then(r => {
            this.Cookies.set("AccessToken", JSON.stringify(r.data), { expires: 1 });
            this.accToken = true
            this.AccessToken = JSON.stringify(r.data)
            if(!this.Cookies.get('DeviceId')) {
              location.reload()
            }
          });
        })
      });
    } else {
      this.accToken = true
    }

    if (
      this.$route.path === "/login" ||
      this.$route.path === "/boss/addSchool"
    ) {
      this.login = true;
    } else {
      this.login = false;
    }
  },
  mounted() {
    if (!sessionStorage.getItem("port")) {
      sessionStorage.setItem("port", "teacher");
    }
    if(this.isMobile_pc()) {
      window.location.href = 'https://ypw-mini-app-0gomme6d24941d20-1305263891.tcloudbaseapp.com'
    }

    if(sessionStorage.getItem('hideFloating')) {
      this.hideFloating = sessionStorage.getItem('hideFloating')
    }
    this.getAggregate()
  },
  methods: {
    // 获取数值
    getAggregate() {
      this.api.post('/62bab8c6be056', {}).then(r=>{
        console.log(r)
        this.aggregate = r.data
      })
    },

    isMobile_pc() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    // 去登陆
    goLogin() {
      this.$router.push({path: '/login'})
    },

    // 关闭浮条
    closeFloatingBar() {
      this.hideFloating = true
      sessionStorage.setItem('hideFloating', this.hideFloating)
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(246, 246, 248);
  color: #414a60;
}
.web {
  width: 1184px;
  margin: 0 auto;
}
.textOverflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<style scoped lang="scss">
  .FloatingBar {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 56px;
    width: 100%;
    background: #FF5B12;
    .FloatingBarBox {
      width: 1184px;
      margin: 0 auto;
      line-height: 56px;
      position: relative;
      .FloatingTitle {
        font-size: 20px;
        margin-left: 30px;
      }
      .FloatingNum {
        margin-left: 20px;
        >span {
          font-size: 20px;
          margin-right: 5px;
        }
      }
      .FloatingLogin {
        border: 1px solid white;
        border-radius: 16px;
        height: 34px;
        line-height: 34px;
        margin-top: 11px;
        padding: 0 9px 0 11px;
        position: absolute;
        right: 35px;
        cursor: pointer;
      }
      .closeFloatingBar {
        position: absolute;
        right: 0;
        font-size: 25px;
        cursor: pointer;
      }
      >span {
        display: inline-block;
        vertical-align: top;
        color: white;
      }
      .pcLogo {
        img {
          height: 33px;
          margin-top: 10px;
        }
      }
    }
  }
  .FloatingBarHeight {
    height: 56px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue